/**
 * @file
 * Responsive behaviors for tables.
 */
/* eslint-disable import/prefer-default-export */

/**
 * Wraps a table that's too wide for its parent in a container with a horizontal
 * scroll bar.
 *
 * @param {HTMLTableElement} element The <table> element to wrap.
 */
export function ResponsiveTableScroll(element) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('table-container');
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
}
